import { useEffect } from 'react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import Lenis from 'lenis'
import { useLenis } from 'lenis/react'
import { useRouter } from 'next/router'

import { useLenisStore } from '@/contexts/lenis'

const Controller = () => {
  const lenis = useLenis()
  const router = useRouter()
  const setLenisState = useLenisStore((state) => state.setState)

  /**
   * Reset scroll position when Lenis mounts.
   * Since LenisRoot remounts on each page transition (unmountOnExit),
   * the new Lenis instance may inherit the previous scroll position.
   */
  useEffect(() => {
    if (!lenis) return
    window.scrollTo(0, 0)
    lenis.scrollTo(0, { immediate: true })
  }, [lenis])

  /**
   * setup
   */
  useEffect(() => {
    if (!lenis) return

    const update = ({ scroll, limit, progress, direction }: Lenis) => {
      setLenisState({
        scroll,
        limit,
        progress,
        direction
      })
    }

    lenis.on('scroll', update)

    return () => {
      lenis.off('scroll', update)
    }
  }, [lenis, setLenisState])

  useEffect(() => {
    ScrollTrigger.clearScrollMemory('manual')

    router.beforePopState((state) => {
      state.options.scroll = false
      return true
    })
  }, [router])

  return null
}

export default Controller
